import { RedrockAccount } from '../admin/store';

export class RedrockAccountViewModel {
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public storeId: number = 0;
}

export class RedrockAccountListViewModel extends RedrockAccountViewModel {
    public accounts: RedrockAccount[] = [];
}

export class RedrockAccountAddOrUpdateViewModel extends RedrockAccountViewModel {
    public account: RedrockAccount = {};
    public id: string = '';
}
